import { type SelectItem } from '../../types'
import { pluralize } from '@terros/common'

const MINI_STEPS = ['roundsDuration', 'seed', 'bracketSize', 'seedingRoundDuration', 'seedingMetric'] as const
export type BracketQuestionMiniStep = (typeof MINI_STEPS)[number]

type BracketSizeOption = {
  label: string
  value: number
}

export const getBracketSizeOptions = (currentParticipantCount: number): BracketSizeOption[] => {
  const sizeOptions = Math.log2(Math.max(2, currentParticipantCount))

  const numberOptions: BracketSizeOption[] = Array.from({ length: Math.floor(sizeOptions) }, (_, index) => {
    const value = getPowerOf2(index)
    return {
      value,
      label: `${value} participants`,
    }
  })

  if (sizeOptions % 1 !== 0) {
    numberOptions.push({
      value: currentParticipantCount,
      label: `${currentParticipantCount} participants (current number of participants)`,
    })
  }

  return numberOptions
}

const getPowerOf2 = (index: number): number => {
  return 2 ** (index + 1)
}

export const ROUND_DURATION_OPTIONS: SelectItem<number>[][] = [
  Array.from({ length: 6 }).map((_, index) => {
    const days = index + 1
    return {
      label: `${days} ${pluralize(days, 'day')}`,
      value: days,
    }
  }),
  Array.from({ length: 4 }).map((_, index) => {
    const weeks = index + 1
    const days = weeks * 7
    return {
      label: `${weeks} ${pluralize(weeks, 'week')}`,
      value: days,
    }
  }),
]
